import { Button, styled } from "@mui/material";


export const ApplyButtonWrapper = styled(Button)((props: any) => ({
    height: "40px",
    backgroundColor: "#1C56CE",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    ":disabled": {
        backgroundColor: "#838383",
    }
}))

export const SetButton: any = styled(Button)({
    width: "100%",
    padding: "0 30px",
    height: "48px",
    color: "#fff",

    backgroundColor: "#3D76EF",
    "&:hover": {
        backgroundColor: "#3D76EF",
    },
    "&:disabled": {
        color: "#FFFFFF",
        backgroundColor: "#707070",
    },
})

